import React, { Component } from 'react'
import PropTypes from 'prop-types'

import idx from 'idx'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'GroupDetailModuleContainer'

    static propTypes = {
      deleteGroup: PropTypes.func.isRequired,
      getGroup: PropTypes.func.isRequired,
      group: PropTypes.object.isRequired,
      groupDone: PropTypes.bool.isRequired,
      groupError: PropTypes.bool.isRequired,
      groupPending: PropTypes.bool.isRequired,
      groupWasDeleted: PropTypes.bool.isRequired,
      redirectToGroups: PropTypes.func.isRequired,
      resetGroup: PropTypes.func.isRequired,
      router: PropTypes.object.isRequired,
      setName: PropTypes.func.isRequired,
      setPermissions: PropTypes.func.isRequired,
    }

    componentDidMount() {
      const { getGroup, groupDone } = this.props
      const { id } = this.props.router.params

      const groupId = idx(this.props, _ => _.group.id)
      const routerGroupId = idx(this.props, _ => _.router.params.id)

      if (!groupDone && id) {
        return getGroup(id)
      }

      if (groupId && routerGroupId) {
        const parsedRouterGroupId = parseInt(routerGroupId, 10)

        if (parsedRouterGroupId !== groupId) {
          return getGroup(parsedRouterGroupId)
        }
      }
    }

    componentDidUpdate() {
      const { groupWasDeleted, redirectToGroups, resetGroup } = this.props

      if (groupWasDeleted) {
        redirectToGroups()
        resetGroup()
      }
    }

    handleDelete = () => {
      const { deleteGroup, group } = this.props

      deleteGroup(group.id)
    }

    handleNameSet = name => {
      const { group, setName } = this.props

      setName(group.id, name)
    }

    handlePermissionsSet = permissions => {
      const { group, setPermissions } = this.props

      setPermissions(group.id, permissions)
    }

    render() {
      const { group, groupError, groupPending } = this.props

      return (
        <WrappedComponent
          group={group}
          handleDelete={this.handleDelete}
          handleNameSet={this.handleNameSet}
          handlePermissionsSet={this.handlePermissionsSet}
          hasError={groupError}
          loaderPending={groupPending && !groupError}
          {...this.props}
        />
      )
    }
  }

  return Container
}
